<ng-container *ngIf="reportState$ | async as report">
    <ng-container *ngIf="componentState$ | async as state">
        <ng-container *ngIf="item">
            <gridster-item [item]="item" (click)="onPreviewInteract()" (mouseenter)="componentHover = true" (mouseleave)="componentHover = false">
                <ng-container [ngSwitch]="state.status">

                    <!-- STATUS SWITCHING -->
                    <ng-container *ngSwitchCase="'OK'">

                        <!-- TYPE SWITCHING -->
                        <ng-container [ngSwitch]="state.component.type">
                            <ng-container *ngSwitchCase="'TEXT'">
                                <pv-report-text
                                    [textControl]="textControl"
                                    [configFormGroup]="configFormGroup"
                                    [item]="item"
                                    [editMode]="editMode"
                                    [gridsterConfig]="gridsterConfig"
                                    (delete)="deleteComponent($event, state.key, state.pageKey)"
                                    (duplicate)="duplicateComponent($event, state.pageKey)">
                                </pv-report-text>
                            </ng-container>

                            <ng-container *ngSwitchCase="'IMAGE'">
                                <pv-report-image
                                    [imageControl]="imageControl"
                                    [configFormGroup]="configFormGroup"
                                    [item]="item"
                                    [editMode]="editMode"
                                    [reportKey]="report.reportKey"
                                    [ownerOrgKey]="report.ownerOrgKey"
                                    [gridsterConfig]="gridsterConfig"
                                    (delete)="deleteComponent($event, state.key, state.pageKey)"
                                    (duplicate)="duplicateComponent($event, state.pageKey)">
                                </pv-report-image>
                            </ng-container>

                            <ng-container *ngSwitchCase="'CHART'">
                                <pv-report-chart
                                    [chartControl]="chartControl"
                                    [configFormGroup]="configFormGroup"
                                    [typography]="typography"
                                    [item]="item"
                                    [editMode]="editMode"
                                    [optionKey]="state.component?.options.key"
                                    [reportKey]="report.reportKey"
                                    [ownerOrgKey]="report.ownerOrgKey"
                                    [compiledData]="state.compiledData"
                                    [status]="state.status"
                                    [gridsterConfig]="gridsterConfig"
                                    (delete)="deleteComponent($event, state.key, state.pageKey)"
                                    (duplicate)="duplicateComponent($event, state.pageKey)"
                                    (editTypography)="openTypography()">
                                </pv-report-chart>
                            </ng-container>

                            <ng-container *ngSwitchCase="'TABLE'">
                                <pv-report-table
                                    [tableControl]="tableControl"
                                    [configFormGroup]="configFormGroup"
                                    [item]="item"
                                    [editMode]="editMode"
                                    [optionKey]="state.component?.options.key"
                                    [reportKey]="report.reportKey"
                                    [ownerOrgKey]="report.ownerOrgKey"
                                    [compiledData]="state.compiledData"
                                    [status]="state.status"
                                    [gridsterConfig]="gridsterConfig"
                                    (delete)="deleteComponent($event, state.key, state.pageKey)"
                                    (duplicate)="duplicateComponent($event, state.pageKey)"
                                    (editTypography)="openTypography()">
                                </pv-report-table>
                            </ng-container>

                            <ng-container *ngSwitchCase="'INDEX'">
                                <pv-report-index
                                    [indexControl]="indexControl"
                                    [configFormGroup]="configFormGroup"
                                    [typography]="typography"
                                    [item]="item"
                                    [editMode]="editMode"
                                    [optionKey]="state.component?.options.key"
                                    [reportKey]="report.reportKey"
                                    [ownerOrgKey]="report.ownerOrgKey"
                                    [compiledData]="state.compiledData"
                                    [status]="state.status"
                                    [gridsterConfig]="gridsterConfig"
                                    (delete)="deleteComponent($event, state.key, state.pageKey)"
                                    (duplicate)="duplicateComponent($event, state.pageKey)"
                                    (editTypography)="openTypography()">

                                </pv-report-index>
                            </ng-container>

                            <ng-container *ngSwitchCase="'GANTT'">
                                <pv-report-gantt
                                    [ganttControl]="ganttControl"
                                    [configFormGroup]="configFormGroup"
                                    [typography]="typography"
                                    [item]="item"
                                    [editMode]="editMode"
                                    [optionKey]="state.component?.options?.key"
                                    [reportKey]="report.reportKey"
                                    [ownerOrgKey]="report.ownerOrgKey"
                                    [compiledData]="state.compiledData"
                                    [status]="state.status"
                                    [gridsterConfig]="gridsterConfig"
                                    (delete)="deleteComponent($event, state.key, state.pageKey)"
                                    (duplicate)="duplicateComponent($event, state.pageKey)"
                                    (editTypography)="openTypography()">
                                </pv-report-gantt>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                <!-- SHOW DEFAULT MESSAGES -->
                                <div class="alternate-wrapper dead-component no-print">
                                    <mat-icon class="material-symbols-outlined" color="warn">dangerous</mat-icon>
                                    <span>Unsupported Component Type</span>
                                </div>
                            </ng-container>
                        </ng-container>

                    </ng-container>

                    <ng-container *ngSwitchCase="'LOADING'">
                        <div class="component-skeleton-wrapper">
                            <div class="component-skeleton"></div>
                        </div>
                    </ng-container>

                    <!-- TODO ADD ERROR UI -->
                    <ng-container *ngSwitchDefault>
                        Error
                    </ng-container>

                </ng-container>

                <div *ngIf="state.saving && editMode" class="saving-indicator no-print" matTooltip="Saving…">
                    <span class="saving-spinner"></span>
                </div>

                <div *ngIf="componentHover && editMode" class="dimension no-print">
                    <mat-icon class="material-symbols-outlined">aspect_ratio</mat-icon>
                    <span>{{ item?.cols || 0 }} &times; {{ item?.rows || 0 }}</span>
                </div>

                <div *ngIf="editMode && fontOverride" class="font-override-badge no-print"
                     [matTooltip]="'Font override: ' + fontOverride">
                    <mat-icon class="material-symbols-outlined">text_fields</mat-icon>
                </div>
            </gridster-item>
        </ng-container>
    </ng-container>
</ng-container>